import { useCallback, useEffect, useState } from 'react';
import { adminRequest, normalizeError } from '../api/adminApi';

const EMPTY_FORM = {
  email: '',
};

function SupportMailsView({ token, onUnauthorized }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editId, setEditId] = useState(null);

  const loadItems = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await adminRequest(token, '/api/admin/support-mail', { onUnauthorized });
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(normalizeError(e));
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [token, onUnauthorized]);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const submit = async (event) => {
    event.preventDefault();
    setError(null);
    try {
      const endpoint = editId ? `/api/admin/support-mail/${editId}` : '/api/admin/support-mail';
      const method = editId ? 'PUT' : 'POST';
      await adminRequest(token, endpoint, {
        method,
        body: JSON.stringify(form),
        onUnauthorized,
      });
      setForm(EMPTY_FORM);
      setEditId(null);
      await loadItems();
    } catch (e) {
      setError(normalizeError(e));
    }
  };

  const beginEdit = (item) => {
    setEditId(item.id);
    setForm({
      email: item.email ?? '',
    });
  };

  const removeItem = async (id) => {
    if (!window.confirm('Delete support e-mail?')) return;
    setError(null);
    try {
      await adminRequest(token, `/api/admin/support-mail/${id}`, {
        method: 'DELETE',
        onUnauthorized,
      });
      await loadItems();
    } catch (e) {
      setError(normalizeError(e));
    }
  };

  return (
    <div className="entities-scroller">
      <form className="entity-form" onSubmit={submit}>
        <h3>{editId ? 'Edit support e-mail' : 'Create support e-mail'}</h3>
        <label>
          E-mail
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm({ email: e.target.value })}
            required
          />
        </label>
        <div className="entity-form-actions">
          <button type="submit">{editId ? 'Save' : 'Create'}</button>
          {editId && (
            <button type="button" onClick={() => { setEditId(null); setForm(EMPTY_FORM); }}>
              Cancel edit
            </button>
          )}
        </div>
      </form>

      {loading && <p className="auth-hint">Loading…</p>}
      {error && <p className="auth-error">{error}</p>}
      {!loading && !error && (
        <table className="entities-table">
          <thead>
            <tr>
              <th>E-mail</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.email}</td>
                <td className="actions-cell">
                  <button type="button" onClick={() => beginEdit(item)}>Edit</button>
                  <button type="button" onClick={() => removeItem(item.id)}>Delete</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={2} className="empty-cell">No support e-mails found.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default SupportMailsView;
